import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-5">
              {t('whatIsH2')}
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-6 text-base">
              {t('whatIsText')}
            </p>
            <Link
              to="/cssbuy-spreadsheet"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('whatIsCta')}
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20photograph%20of%20a%20tablet%20showing%20an%20organized%20spreadsheet%20grid%20beside%20neatly%20arranged%20product%20photos%20and%20sticky%20notes%20on%20a%20bright%20white%20desk%20soft%20natural%20light%20high%20detail%20minimalist%20data%20organization%20concept&width=800&height=600&seq=what-is-img&orientation=landscape&nocache=true"
              alt="CSSBuy Spreadsheet Research"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}